<template>
	<div class="upload">
		<img v-if="!isPDF" :src="ossImg(url,'s')" alt="">
		<img v-if="isPDF" width="100%" src="/static/images/haierProduct/pdf.png">
		<a class="mt10" v-if="!isPDF" :href="ossImg(url)" target="_blank">查看大图</a>
		<a class="mt10" v-if="isPDF" :href="url" target="_blank">查看大图</a>
		<a @click="$emit('del-img')" v-if="$route.query.orderType==1&&del" style="color:red">删除</a>
	</div>
</template>
<script>
export default {
	props:{
		url:String,
		del:{
			type: Boolean,
			default:false
		}
	},
	computed:{
		isPDF(){
			return this.url.toLowerCase().endsWith('.pdf');
		}
	}
}
</script>
<style scoped lang="less">
.upload{
	margin-right: 10px;
	// width:100%;
	// height:100%;
	text-align:center;
	position:relative;
	img{
		width:100%;
		// height:140px;
	}
	a{
		position: relative;
    	top: -15px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/Image.vue